import React from "react"
import { Modal, Typography } from "antd"
import { BulkUpdateForm } from "./BulkUpdateForm"

export const BulkUpdateModal = ({
  open,
  selectedCount,
  onSubmit,
  onCancel,
}) => {
  return (
    <Modal
      title={
        <Typography.Title level={4} style={{ color: "#7BAD7E", margin: 0 }}>
          Bulk Update {selectedCount} Template{selectedCount !== 1 ? "s" : ""}
        </Typography.Title>
      }
      open={open}
      onCancel={onCancel}
      footer={null}
      destroyOnClose
      width="50vw"
      centered
    >
      <BulkUpdateForm
        selectedCount={selectedCount}
        onSubmit={onSubmit}
        onCancel={onCancel}
      />
    </Modal>
  )
}
